import { Box, Button, Grid, Paper, Typography, Stack } from "@mui/material";
import {useNavigate, useLocation, Link} from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout/AuthLayout";
import { useTheme } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { useAuthContext } from "../contexts/AuthContext";
import { AlignHorizontalCenter, DisplaySettings } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import styles from '../../../layouts/AppLayout/MainNav/MainNav.module.scss';
import { AppColor, Fonts } from "../../../types/Constants";
import DoneIcon from '@mui/icons-material/Done';
import jwtAxios from "../../../utils/jwtAxios";
import UserProfileDialog from '../../../features/authentication/dialogs/UserProfileDialog';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SubscriptionTable from "../../subscriptions/SubscriptionTable";

function SubscriptionPage() {
    let theme = useTheme();
    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuthContext();

    const [pageError, setPageError] = useState<string>("");
    const [isOpenUserProfile, setIsOpenUserProfile] = useState<boolean>(false);
  
    let from = location.state?.from?.pathname || "/beacons";

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body1,
        padding: theme.spacing(3),
        textAlign: 'center',
      }));

      const handleSubscription = (tier: string ) => {
        const apiUrl = "/api/subscription/subscribe?tier=" + tier;

        jwtAxios.post(apiUrl)
            .then(response => {
                window.location.href = response.data.url;
            })
            .catch(error => {
                console.error('There was a problem with the API request:', error);
            });
    };

return (
    <>
    <Box height="100vh" style={{}}>
          <Box
            sx={{
              display: "flex",
              p: 1,
              borderRadius: 2,
              justifyContent: "flex-end"
            }}
            onClick={() => setIsOpenUserProfile(true)}
          >
            <Box
            sx={{
              display: "flex",
              p: 1,
              mr: 1,
              mt: 2,
              width: "fit",
              borderRadius: 2,
              justifyContent: "flex-end",
              "&:hover": { backgroundColor: AppColor.orangeBoldBackground },
            }}
            onClick={() => setIsOpenUserProfile(true)}
            >
            <Box
              sx={{
                display: "flex",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: AppColor.baseOrange,
                color: "black",
              }}
            >
              <PersonOutlineOutlinedIcon
                sx={{ color: "white", fontSize: 18, fontWeight: Fonts.LIGHT }}
              />
            </Box>
            <Box sx={{ ml: 2, mt: "2px" }}>
              <Typography className={styles.mainNav}>
                {auth.preferredUserName ?? auth.user}
              </Typography>
            </Box>
            <Box
              sx={{
                ml: 1,
                mt: "3px",
                display: "flex",
                color: "black",
              }}
            >
              <ExpandMoreIcon />
          </Box>
        </Box>
        </Box>
    <Box justifyContent="center">
        <Box padding={theme.spacing(8)}>
            <Typography variant="h4" align="center" mb={4} fontWeight="600">Choose Your Subscription</Typography>
            <Typography variant="subtitle1" textAlign="center" maxWidth="50%" margin="auto"> A subscription is required to gain access to Skidattl.</Typography>
        </Box>
    </Box>
    
    <SubscriptionTable currentSubscription={""} pricingTiers={[]} currentInterval={""} dashboardRequired={false}/>

    </Box>
    <UserProfileDialog
        isOpen={isOpenUserProfile}
        onClose={() => setIsOpenUserProfile(false)}
        isSSO={auth.isSSOUser}
    />
    </>
  );
}

export default SubscriptionPage;